<template>
  <!-- 显示单个定位的地图组件 -->
  <div>
    <div id="showAllOnMap"></div>
    <!-- <el-button size="mini"
               @click="test">测试</el-button> -->
  </div>

</template>

<script>
// let marker
export default {
  name: 'show-all-location-on-map',
  data() {
    return {
      map: {},
      marker: {},
      pointerListOnMap: [],
      lat: this.latprop,
      lng: this.lngprop,
    }
  },
  props: {
    residenceId: String,
    latprop: {
      type: Number,
      default: 18.22896559265385,
    },
    lngprop: {
      type: Number,
      default: 109.5366628197371,
    },
    poiList: {
      type: Array,
      default: [],
    },
  },

  mounted() {
    // console.log(this.poiList)
    this.init()
  },
  methods: {
    init() {
      let center = new TMap.LatLng(this.lat, this.lng)
      //初始化地图
      this.map = new TMap.Map('showAllOnMap', {
        zoom: 17, //设置地图缩放级别
        mapStyleId: 'style1',
        center: center, //设置地图中心点坐标
      })
      // 去掉比例尺
      this.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.SCALE)
      this.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION)
      // ------------------创建点标记实例------------------
      this.marker = new TMap.MultiMarker({
        map: this.map,
        // 标记点的样式，其中myStyle 为定义的标记点的名称，在geometries的属性是使用
        styles: {
          markerStyle: new TMap.MarkerStyle({
            width: 17,
            height: 17,
            anchor: { x: 8, y: 16 },
            src: 'http://szsxtravel.top/%E5%9D%90%E6%A0%87.png',
          }),
          markerResidence: new TMap.MarkerStyle({
            width: 28,
            height: 28,
            anchor: { x: 16, y: 32 },
            src: 'http://szsxtravel.top/residenceMarker.png',
          }),
          selectTraver: new TMap.MarkerStyle({
            width: 35,
            height: 35,
            anchor: { x: 16, y: 32 },
            src: 'http://szsxtravel.top/%E5%9D%90%E6%A0%87.png',
          }),
        },
        geometries: [], //点标记数据数组
      })
      this.setMarkerPointerCenter(this.lat, this.lng)
      //
      // console.log(this.marker)
      // 创建 点标记 监听事件
      let that = this
      let traverPointerClick = function (evt) {
        // console.log(evt.geometry.id)
        that.$emit('clickMapTraverPoint', evt.geometry)
      }
      this.marker.on('click', traverPointerClick)
    },
    eventClick() {
      console.log('ss')
    },
    // 定位酒店坐标，并设置中心点
    setMarkerPointerCenter(lat, lng) {
      let center = new TMap.LatLng(lat, lng)
      this.marker.add({
        id: 'residence',
        styleId: 'markerResidence',
        position: center,
      })
      // 设置中心
      this.map.setCenter(center)
    },
    // 添加标记点组
    pointerOnMap() {
      // console.log(this.poiList)
      this.pointerListOnMap = []
      // 创建 标点 选项
      this.poiList.forEach((res) => {
        let item = {
          // 列表选项参考文档：https://lbs.qq.com/webApi/javascriptGL/glGuide/glMarker
          id: res.id,
          styleId: 'markerStyle', // 标记点的样式
          position: new TMap.LatLng(res.lat, res.lng),
          properties: {
            //自定义属性
            title: 'marker1',
          },
        }
        this.pointerListOnMap.push(item)
      })
      // console.log(this.pointerListOnMap)
      // 添加标记点
      // console.log('点标记对象', this.marker)
      this.marker.add(this.pointerListOnMap)
    },
    // 点击卡片 根据id 变换样式
    clickOnPointer(point_id, lat, lng) {
      let center = new TMap.LatLng(lat, lng)
      this.pointerListOnMap.forEach((item) => {
        if (item.id == point_id) {
          item.styleId = 'selectTraver'
        } else {
          item.styleId = 'markerStyle'
        }
      })
      //
      // if (this.marker) {
      //   // 清除点标记
      //   this.marker.setMap(null)
      //   this.marker = null
      // }
      this.marker.add(this.pointerListOnMap)
      this.map.setCenter(center)
    },
    // 添加一个点标记
    addOneMarker(residence_id, lat, lng) {
      let center = new TMap.LatLng(lat, lng)
      this.marker.add({
        id: residence_id,
        styleId: 'markerResidence',
        position: center,
      })
      this.map.setCenter(center)
    },
    // 移除一个坐标
    removeMarkerPointer(marker_id) {
      this.marker.remove(marker_id)
    },

    // -----------------------------显示地图边界-----------------------------
    showMarkerBounds(markerArr) {
      // 创建对象：描述一个矩形的地理坐标范围。https://lbs.qq.com/javascript_gl/doc/latlngbounds.html
      var bounds = new TMap.LatLngBounds()
      //判断标注点是否在范围内
      markerArr.forEach(function (item) {
        //若坐标点不在范围内，扩大bounds范围
        if (bounds.isEmpty() || !bounds.contains(item.position)) {
          bounds.extend(item.position)
        }
      })
      //设置地图可视范围
      this.map.fitBounds(bounds, {
        padding: 100, // 自适应边距
      })
    },
  },
}
</script>

<style>
#showAllOnMap {
  width: auto;
  height: 450px;
  /* margin-top: 20px; */
}
</style>